
        var result = require("!!./../../../node_modules/css-loader/index.js!./stil-mrtav.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/komponente/ishod/stil-mrtav.css
// module id = 53
// module chunks = 0